import { render, staticRenderFns } from "./FrameHeader.vue?vue&type=template&id=22d3c21e"
import script from "./FrameHeader.vue?vue&type=script&lang=ts"
export * from "./FrameHeader.vue?vue&type=script&lang=ts"
import style0 from "./FrameHeader.vue?vue&type=style&index=0&id=22d3c21e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports